import { BusinessSection } from "@/components/BusinessSection";
import { ContactSection } from "@/components/ContactSection";
import { PageShell } from "@/components/PageShell";
import { HeroSection } from "@/components/hero/HeroSection";
import { HospitalityPanels } from "@/components/HospitalityPanels";
import { HowItWorksSection } from "@/components/HowItWorksSection";
import { IntelligenceSection } from "@/components/IntelligenceSection";
import { TeamSection } from "@/components/TeamSection";
import { PreviewGate } from "@/components/PreviewGate";
import { AboutPage } from "@/pages/AboutPage";
import { ContactPage } from "@/pages/ContactPage";
import { MeetSomoPage } from "@/pages/MeetSomoPage";
import { QuotePage } from "@/pages/QuotePage";
import { lazy, Suspense, type ReactNode } from "react";
import { SITE } from "@/lib/site";

// Kept out of the main bundle so the site pages don't download them.
const SavingsCalculatorPage = lazy(() =>
  import("./savings-calculator/SavingsCalculatorPage").then((module) => ({
    default: module.SavingsCalculatorPage,
  })),
);
const LogoPage = lazy(() =>
  import("./LogoPage").then((module) => ({ default: module.LogoPage })),
);

export default function App() {
  const pathname = window.location.pathname.replace(/\/$/, "");
  if (pathname === "/savings-calculator") {
    return (
      <div className="font-geist">
        <PreviewGate
          flag="hotelSavingsCalculatorPasswordGate"
          name="The savings calculator"
        >
          <Suspense>
            <SavingsCalculatorPage />
          </Suspense>
        </PreviewGate>
      </div>
    );
  }

  const sitePage = SITE_PAGES[pathname];
  if (!sitePage) {
    return (
      <Suspense>
        <LogoPage />
      </Suspense>
    );
  }

  return <PreviewGate name="The new Somo website">{sitePage}</PreviewGate>;
}

const SITE_PAGES: Record<string, ReactNode> = {
  [SITE]: <HomePage />,
  [`${SITE}/meet-somo`]: <MeetSomoPage />,
  [`${SITE}/about`]: <AboutPage />,
  [`${SITE}/contact`]: <ContactPage />,
  [`${SITE}/get-a-quote`]: <QuotePage />,
};

function HomePage() {
  return (
    <PageShell className="bg-primary">
      <HeroSection />
      <HospitalityPanels />
      <BusinessSection />
      <HowItWorksSection />
      <IntelligenceSection />
      <TeamSection />
      <ContactSection />
    </PageShell>
  );
}
